<template>
    <b-card-group deck>
        <b-card bg-variant="light" header="Índice de Barthel">
    
            <b-form-group label="01 - Alimentar-se">
                <b-form-radio-group v-model="barthel.quesitoUm"
                                    :options="quesitoUm"
                                    stacked
                                    name="quesitoUm">
                </b-form-radio-group>
            </b-form-group>

            <b-form-group label="02 - Tomar Banho">
                <b-form-radio-group v-model="barthel.quesitoDois"
                                    :options="quesitoDois"
                                    stacked
                                    name="quesitoDois">
                </b-form-radio-group>
            </b-form-group>
        
            <b-form-group label="03 - Higiene Pessoal">
                <b-form-radio-group v-model="barthel.quesitoTres"
                                    :options="quesitoTres"
                                    stacked
                                    name="quesitoTres">
                </b-form-radio-group>
            </b-form-group>   
        
            <b-form-group label="04 - Vestir-se">
                <b-form-radio-group v-model="barthel.quesitoQuatro"
                                    :options="quesitoQuatro"
                                    stacked
                                    name="quesitoQuatro">
                </b-form-radio-group>
            </b-form-group>   

            <b-form-group label="05 - Controle Esfinceteriano">
                <b-form-radio-group v-model="barthel.quesitoCinco"
                                    :options="quesitoCinco"
                                    stacked
                                    name="quesitoCinco">
                </b-form-radio-group>
            </b-form-group>   

            <b-form-group label="06 - Controle Urinário">
                <b-form-radio-group v-model="barthel.quesitoSeis"
                                    :options="quesitoSeis"
                                    stacked
                                    name="quesitoSeis">
                </b-form-radio-group>
            </b-form-group>   

            <b-form-group label="07 - Ir ao Banheiro">
                <b-form-radio-group v-model="barthel.quesitoSete"
                                    :options="quesitoSete"
                                    stacked
                                    name="quesitoSete">
                </b-form-radio-group>
            </b-form-group>   

            <b-form-group label="08 - Locomoção da Cama para Cadeira">
                <b-form-radio-group v-model="barthel.quesitoOito"
                                    :options="quesitoOito"
                                    stacked
                                    name="quesitoOito">
                </b-form-radio-group>
            </b-form-group>   

            <b-form-group label="09 - Deambulação">
                <b-form-radio-group v-model="barthel.quesitoNove"
                                    :options="quesitoNove"
                                    stacked
                                    name="quesitoNove">
                </b-form-radio-group>
            </b-form-group>   

            <b-form-group label="10 - Subir Escadas">
                <b-form-radio-group v-model="barthel.quesitoDez"
                                    :options="quesitoDez"
                                    stacked
                                    name="quesitoDez">
                </b-form-radio-group>
            </b-form-group>

            <button type="button" class="btn btn-success" @click="contabilizar()">Contabilizar Índice de Barthel</button>  



        </b-card>
    </b-card-group>
</template>

<script>
export default {
    mounted () {
        this.barthel = {
            quesitoUm: '',
            quesitoDois: '',
            quesitoTres: '',
            quesitoQuatro: '',
            quesitoCinco: '',
            quesitoSeis: '',
            quesitoSete: '',
            quesitoOito: '',
            quesitoNove: '',
            quesitoDez: '',
        }
    },
    data () {
        return {
            barthel: {
                quesitoUm: '',
                quesitoDois: '',
                quesitoTres: '',
                quesitoQuatro: '',
                quesitoCinco: '',
                quesitoSeis: '',
                quesitoSete: '',
                quesitoOito: '',
                quesitoNove: '',
                quesitoDez: '',
            },
            quesitoUm: [
                { text: 'Alimenta-se de forma independente. É capaz de fazer uso de qualquer utensílio necessário. Se alimenta em um tempo razoável. (10)', value: 10 },
                { text: 'Precisa de ajuda (ex. para partir os alimentos) (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoDois: [
                { text: 'Toma banho sem necessidade de ajuda. (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoTres: [
                { text: 'Lava o rosto, penteia o cabelo, escova os dentes, faz a barba (liga o barbeador na tomada, se elétrico) (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoQuatro: [
                { text: 'Se veste de forma independente. Amarra os sapatos, afivela o cinto, consegue abotoar. (10)', value: 10 },
                { text: 'Precisa de ajuda mas faz ao menos parte das coisas necessárias em um tempo razoável. (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoCinco: [
                { text: 'Não apresenta problemas. É capaz de fazer uso de fleet enema ou supositório, se necessário. (10)', value: 10 },
                { text: 'Problemas ocasionais ou necessita de ajuda para utilizar fleet enema ou supositório. (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoSeis: [
                { text: 'Não apresenta problemas. Capaz de manusear o coletor, se o utiliza. (10)', value: 10 },
                { text: 'Problemas ocasionais ou necessita de ajuda para manusear os coletores. (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoSete: [
                { text: 'Capaz de ir ao banheiro ou de utilizar a comadre. Capaz de fazer uso do papel higiênico, dar descarga ou limpar a comadre. (10)', value: 10 },
                { text: 'Precisa de ajuda para se equilibrar, para se vestir ou utilizar o papel higiênico. (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoOito: [
                { text: 'Consegue se mobilizar de forma independente, inclusive travar as rodas da cadeira e suspender os suportes para os pés. (15)', value: 15 },
                { text: 'Necessita de ajuda mínima ou supervisão. (10)', value: 10 },
                { text: 'É capaz de se sentar, mas precisa de ajuda para se locomover da cama para a cadeira ou vice-versa. (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoNove: [
                { text: 'É capaz de andar ... metros sozinho. Pode fazer uso de muletas, se necessário. (15)', value: 15 },
                { text: 'Precisa de ajuda para andar ... metros. (10)', value: 10 },
                { text: 'É capaz de se locomover na cadeira de rodas ... metros, somente se for incapaz de andar. (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
            quesitoDez: [
                { text: 'É capaz de subir sozinho. Pode utilizar algum acessório para ajuda, se necessário. (10)', value: 10 },
                { text: 'Precisa de ajuda ou supervisão. (5)', value: 5 },
                { text: 'Performance menor do que as anteriores. (0)', value: 0 }
            ],
        }
    },
    methods: {
        contabilizar () {
            if ( 
                    this.barthel.quesitoUm === ''       || 
                    this.barthel.quesitoDois === ''     || 
                    this.barthel.quesitoTres === ''     || 
                    this.barthel.quesitoQuatro === ''   || 
                    this.barthel.quesitoCinco === ''    || 
                    this.barthel.quesitoSeis === ''     || 
                    this.barthel.quesitoSete === ''     || 
                    this.barthel.quesitoOito === ''     || 
                    this.barthel.quesitoNove === ''     || 
                    this.barthel.quesitoDez === '' 
                )
            {
                alert('Preencha todas as perguntas')
                return
            }
            
            let dados = this.barthel.quesitoUm + this.barthel.quesitoDois + this.barthel.quesitoTres + this.barthel.quesitoQuatro + this.barthel.quesitoCinco + this.barthel.quesitoSeis + this.barthel.quesitoSete + this.barthel.quesitoOito + this.barthel.quesitoNove + this.barthel.quesitoDez
            
            this.$emit('contabilidadeBarthel', dados)
        }
    }
}
</script>